module.exports = __webpack_public_path__ + "img/icon1_qs.0712707e.png";